export enum Step {
  COSA = "cosa",
  SCONTO = "sconto-finanziamento",
}
